import { SelectOption } from '@globaleris/ui.library'
import {
  CUPSModel,
  DistributorModel,
  LogisticElementModel
} from '../../api/Argentia/model/contracts'
import { CupsDetailsEditForm } from './details/cups.details'
import { logisticElementMapperToDropDown } from '../buyandsell/buyandsell.mapper'

export const mapModelToSelectOptionArray = (
  modelArray: DistributorModel[] | LogisticElementModel[] | undefined,
  isLogisticElement = false
): SelectOption[] => {
  if (modelArray) {
    return modelArray.map(modelElement =>
      mapDistributorToSelectOption(modelElement, isLogisticElement)
    )
  } else {
    return [{ value: 0, label: '' }]
  }
}

const mapDistributorToSelectOption = (
  modelElement: DistributorModel | LogisticElementModel,
  isLogisticElement: boolean
): SelectOption => {
  return {
    value: modelElement.id!,
    label:
      isLogisticElement && modelElement.code
        ? `${modelElement.code} - ${modelElement.description}`
        : modelElement.description
  }
}

export const mapCupsDetailsEditFormData = (
  responseData: CUPSModel[] | undefined
): CupsDetailsEditForm => {
  if (responseData && responseData?.length > 0) {
    return {
      id: responseData[0].id,
      CUPSCode: responseData[0].code,
      distributorId: responseData[0].distributor?.id ?? 0,
      logisticElementId: responseData[0].logisticElement?.id ?? 0,
      distributorGroupId: responseData[0].distributor?.distributorGroup?.id ?? 0
    }
  }

  return {} as CupsDetailsEditForm
}
